import baseAxios from '@/services/axios_base.js'

export const useDistributorsService = () => {
  const runtimeConfig = useRuntimeConfig()
  const baseurl = runtimeConfig.public.DISTRIBUTOR_SEARCH_INDEX_URL

  const dist_search_axios = baseAxios.create({
    baseURL: baseurl
  })

  const getDistributors = async function (searchLng = null, searchLat = null, classification = null, testApiKey = null) {
    const apiKey = testApiKey || runtimeConfig.public.DISTRIBUTOR_SEARCH_API_KEY
    const config = {
      headers: {
        'api-key': apiKey
      },
      params: {
        $count: true,
        $top: 9999,
        search: '*',
        'api-version': '2021-04-30-Preview',
        'facet': 'PartnerTypes'
      }
    }
    if (searchLng && searchLat) {
      config.params.$orderby = `geo.distance(Location, geography'POINT(${searchLng} ${searchLat})') asc`
    }

    if (Array.isArray(classification) && classification.length > 0) {
      config.params.$filter = `PartnerTypes/any(p: search.in(p,'${classification.map(v => `${v}`).join(',')}',','))`
    }

    const res = await dist_search_axios.get('/docs', config).catch(() => {return null})
    return {distributors: res?.data?.value
      .map(v => {
        const lngLatPairObj = {
          lng: null,
          lat: null
        }
        if (v.Location?.coordinates?.length === 2) {
          lngLatPairObj.lng = v.Location.coordinates[0]
          lngLatPairObj.lat = v.Location.coordinates[1]
        }
        return {...v, gps: !lngLatPairObj.lng || !lngLatPairObj.lat ? null : lngLatPairObj}
      }), partnerTypes: res?.data?.['@search.facets']?.PartnerTypes.map(v => ({text: v.value, value: v.value}))}
  }

  const getDistributorById = async function (id, testApiKey = null) {
    const apiKey = testApiKey || runtimeConfig.public.DISTRIBUTOR_SEARCH_API_KEY
    const config = {
      headers: {
        'api-key': apiKey
      },
      params: {
        $count: true,
        $top: 1,
        $filter: `Id eq '${id}'`,
        'api-version': '2021-04-30-Preview'
      }
    }

    const res = await dist_search_axios.get('/docs', config).catch(() => {return null})

    return res?.data?.value
      .map(v => {
        const lngLatPairObj = {
          lng: null,
          lat: null
        }
        if (v.Location?.coordinates?.length === 2) {
          lngLatPairObj.lng = v.Location.coordinates[0]
          lngLatPairObj.lat = v.Location.coordinates[1]
        }
        return {...v, gps: !lngLatPairObj.lng || !lngLatPairObj.lat ? null : lngLatPairObj}
      })
  }

  return {getDistributors, getDistributorById}
}
